import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useLatestCoachNote } from "../../coachNoteApi";
import { formatWhen } from "../../lib/formatWhen";
import { localeFor } from "../../lib/dateLocale";

/**
 * Canon section ScreenPlanCoached (main.dc.html:885-927): coach update anchor
 * row above plan content. Surfaces «{COACH} · {TIME} · ПЛАН ОБНОВЛЁН»
 * + 1-line note explaining what changed. До v153 reachable only через
 * /chat — атлет не видел plan-level coach signal на Plan page.
 *
 * Source: useLatestCoachNote() (existing, used by Today). Renders
 * только когда note есть AND coach_name present — для Solo athletes
 * note будет null (backend default-deny) и component вернёт null.
 */


export function PlanCoachUpdateAnchor() {
  const { t, i18n } = useTranslation("plan");
  const { data: note } = useLatestCoachNote();

  if (!note || !note.coach_name) return null;

  const initial = note.coach_name.charAt(0).toUpperCase();
  // Голое HH:MM для заметки трёхдневной давности читается как сегодняшнее.
  const time = formatWhen(note.updated_at || note.created_at, localeFor(i18n.language)) ?? "";
  const coachUpper = note.coach_name.toUpperCase();

  return (
    <Link
      to="/chat"
      data-testid="plan-coach-update-anchor"
      className="block indigo-card p-3 hover:bg-bg-raised transition-colors"
      style={{ borderLeft: "2px solid var(--accent)" }}
    >
      <div className="flex items-center gap-3">
        <div
          aria-hidden
          className="w-9 h-9 rounded-full bg-accent/15 border border-accent/30 flex items-center justify-center shrink-0 text-fg-primary text-sm font-bold num-display"
        >
          {initial}
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[10px] font-mono font-bold uppercase tracking-[0.22em] text-fg-muted truncate">
            {coachUpper}
            {time && (
              <span className="text-fg-muted ml-1.5">· {time}</span>
            )}
            <span className="text-accent ml-1.5">
              · {t("coach_update.label", { defaultValue: "ПЛАН ОБНОВЛЁН" })}
            </span>
          </div>
          <div className="text-[12px] text-fg-secondary mt-1 leading-snug line-clamp-2 whitespace-pre-wrap">
            {note.content}
          </div>
        </div>
      </div>
    </Link>
  );
}
